/**
 * The age at which a person consents to DivePeaks by themselves: 14 (art.
 * 2-quinquies Codice privacy, art. 8 GDPR). Below it the consent is a parent's
 * or guardian's. The one age threshold the app enforces — a 14–17 year old is
 * an adult to us. Mirrors `ConsentAge` on the server, which has the last word.
 */
export const CONSENT_AGE_YEARS = 14;

/**
 * Whether somebody born on `birthDate` (ISO `YYYY-MM-DD`) is under the consent
 * age today. False for a missing or unreadable date: the desk said nothing,
 * and we do not guess.
 */
export function isUnderConsentAge(birthDate: string | null | undefined, today = new Date()): boolean {
  if (!birthDate) return false;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(birthDate);
  if (!match) return false;

  const born = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  if (Number.isNaN(born.getTime())) return false;

  // The day they turn 14: born after the same date 14 years ago means not yet.
  const threshold = new Date(today.getFullYear() - CONSENT_AGE_YEARS, today.getMonth(), today.getDate());
  return born > threshold;
}
